
<template>
  <div>
    <header>
      <section>
        <div class="col1">
          <router-link id="logo" to="uploader"
            ><h3>JustOneMore</h3></router-link
          >
        </div>
      </section>
    </header>
    <div>
      <div class="md-form container container-custom">
        <div class="form-group">
          Total usuarios:
          {{ total_users }},
          Usuarios registrados hoy:
          {{ today_users }},
          Ultima semana:
          {{ last_week_users }},
          Ultimo mes:
          {{ last_month_users }}
        </div>
        <div class="form-group">
          Total de free trials:
          {{ total_free_trials }}
          Free trials hoy:
          {{ today_free_trials }}
          Ultima semana:
          {{ last_week_free_trials }}
          Ultimo mes:
          {{ last_month_free_trials }}
        </div>
        <div class="form-group">
          Total uploads:
          {{ total_uploads }}
          Uploads creados hoy:
          {{ today_uploads }}
          Ultima semana:
          {{ last_week_uploads }}
          Ultimo mes:
          {{ last_month_uploads }}
        </div>
        <div class="form-group">
          Total reproducciones:
          {{ total_reproductions }}
          Reproducciones hoy:
          {{ today_reproductions }}
          Ultima semana:
          {{ last_week_reproductions }}
          Ultimo mes:
          {{ last_month_reproductions }}
        </div>
        <div class="form-group">
          Total historias compartidas:
          {{ total_shared }}
          Compartidas hoy:
          {{ today_shared }}
          Ultima semana:
          {{ last_week_shared }}
          Ultimo mes:
          {{ last_month_shared }}
        </div>
        <div class="form-group">
          Ultimos 100 usuarios:
          <v-data-table
            :headers="last_users_headers"
            :items="last_users_rows"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
        </div>
        <div class="form-group">
          Historias mas reproducidas:
          <v-data-table
            :headers="stories_headers"
            :items="stories_rows"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
        </div>
        <div class="form-group">
          Usuarios mas activos:
          <v-data-table
            :headers="active_users_headers"
            :items="active_users_rows"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
        </div>
        <!--
        <div class="form-group">
          <label>Author:</label>
          <input
            v-model.trim="uploadInfo.author"
            class="form-control"
            required
          />
        </div> -->
        <!-- <div class="form-group">
          <span>Story is original: </span
          ><input
            style="width: auto; display: inline"
            type="checkbox"
            name="vehicle1"
            v-model="uploadInfo.original"
          />
        </div> -->
        <!-- <div class="form-group">
          <label for="exampleFormControlSelect1">Story language:</label>
          <select
            value="English"
            v-model.trim="uploadInfo.language"
            class="form-control"
            v-on:change="handleLanguageChange"
            required
          >
            <option selected="selected">English</option>
            <option>Spanish</option>
            <option>Other</option>
          </select>
          <input
            id="inputLanguage"
            v-model.trim="uploadInfo.other"
            class="form-control"
            placeholder="Other language"
          />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ApiService from "@/services/api/Mainapi";
export default {
  data() {
    this.getAllMetricsData().then(
    );
    return {
      allMetricsData: null,
      total_users: null,
      today_users: null,
      last_week_users: null,
      last_month_users: null,
      total_free_trials: null,
      today_free_trials: null,
      last_week_free_trials: null,
      last_month_free_trials: null,
      total_uploads: null,
      today_uploads: null,
      last_week_uploads: null,
      last_month_uploads: null,
      total_reproductions: null,
      today_reproductions: null,
      last_week_reproductions: null,
      last_month_reproductions: null,
      total_shared: null,
      today_shared: null,
      last_week_shared: null,
      last_month_shared: null,
      last_users_headers: [
        { text: 'Email', value: 'email' },
        { text: 'Created at', value: 'createdat' },
        { text: 'Updated at', value: 'updatedat' },
      ],
      last_users_rows: [],
      stories_headers: [
        { text: 'Title', value: 'title'},
        { text: 'Reproducciones', value: 'reproducciones'}
      ],
      stories_rows: [],
      active_users_headers: [
        { text: 'Email', value: 'email'},
        { text: 'Reproducciones', value: 'reproducciones'}
      ],
      active_users_rows: [],
    };
  },
  methods: {
    async getAllMetricsData() {
      ApiService.getMetricts().then(data => {
        this.allMetricsData = data;
        this.getNumberOfUsers(data);
        this.getFreeTrialsInfo(data);
        this.getUploadsInfo(data);
        this.getReproductionsInfo(data);
        this.getSharedInfo(data);
        this.getLastUsersInfo(data.last_x_users);
        this.getPopularStoriesInfo(data.most_popular_stories);
        this.getActiveUsersInfo(data.most_active_users);
      }).catch(err => {
        console.log("ERROR: " + err.message);
      })
    },
    getNumberOfUsers(data) {
      this.total_users = data.number_of_users;
      this.today_users = data.number_of_users_today;
      this.last_week_users = data.number_of_users_last_week;
      this.last_month_users = data.number_of_users_last_month;
    },
    getFreeTrialsInfo(data) {
      this.total_free_trials = data.started_free_trial_total;
      this.today_free_trials = data.started_free_trial_today;
      this.last_week_free_trials = data.started_free_trial_last_week;
      this.last_month_free_trials = data.started_free_trial_last_month;
    },
    getUploadsInfo(data) {
      this.total_uploads = data.number_uploaded_stories;
      this.today_uploads = data.number_uploaded_stories_today;
      this.last_week_uploads = data.number_uploaded_stories_last_week;
      this.last_month_uploads = data.numbber_uploaded_stories_last_month;
    },
    getReproductionsInfo(data) {
      this.total_reproductions = data.number_reproductions;
      this.today_reproductions = data.number_reproductions_today;
      this.last_week_reproductions = data.number_reproductions_last_week;
      this.last_month_reproductions = data.number_reproductions_last_month;
    },
    getSharedInfo(data) {
      this.total_shared = data.number_shared_stories;
      this.today_shared = data.number_shared_stories_today;
      this.last_week_shared = data.number_shared_stories_last_week;
      this.last_month_shared = data.number_shared_stories_last_month;
    },
    getLastUsersInfo(data) {
      var i;
      var last_users_json = [];
      for (i = 0; i < data.length; i++) {
         last_users_json.push({
           "email": data[i][0],
           "createdat": data[i][1],
           "updatedat": data[i][2]
         })
      }
      this.last_users_rows = last_users_json;
    },
    getPopularStoriesInfo(data) {
      var i;
      var popular_stories_json = [];
      for(i = 0; i < data.length; i++) {
        popular_stories_json.push({
          "title": data[i][0],
          "reproducciones": data[i][1]
        })
      };
      this.stories_rows = popular_stories_json;
    },
    getActiveUsersInfo(data) {
      var i;
      var active_users_json = [];
      for(i = 0; i < data.length; i++) {
        active_users_json.push({
          "email": data[i][0],
          "reproducciones": data[i][1]
        })
      }
      this.active_users_rows = active_users_json;
    }
  },
};
</script>

<style>
body {
  background-color: white;
}
.container-custom {
  margin-top: 20px;
}
textarea {
  min-height: 125px;
}
#logo {
  position: fixed;
  display: flex;
}
#inputLanguage {
  margin-top: 10px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics.vue